import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchRoleListData() {
  const response = await instance.get(`/rolebase/getRolesList`);
  return response.data;
}
export async function fetchModuleListData() {
  const response = await instance.get(`/rolebase/getUserModuleList`);
  return response.data;
}
export async function fetchUserListData(data:any) {
  const response = await instance.get(`/users/getAllUsers?sector=${data.sectorId}&bu=${data.buId}`);
  return response.data;
}
export async function fetchUserListExcludedData(data:any) {
  const response = await instance.get(`/users/getExcludedUsers?sector=${data.sectorId}&bu=${data.buId}`);
  return response.data;
}
export async function fetchUpdateRole(data:any) {
  const response = await instance.put(`/rolebase/updateRoleList?roleId=${data.roleId}`, data.data);
  return response.data;
}
export async function fetchUserPermisionData() {
  const response = await instance.get(`/rolebase/getUserPermission`);
  return response.data;
}
export async function fetchAdminListData(data:any) {
  const response = await instance.get(`/verify/user/userbytype/${data}`);
  return response.data;
}





